"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appArtifactRoutePath = appArtifactRoutePath;
exports.findAppArtifactRoute = findAppArtifactRoute;
exports.resolvePortalReturnPath = resolvePortalReturnPath;
/**
 * The pages of an App Container by their path, alike for the platform and the
 * StreamKit: one normalization, exact before dynamic, and the pages a portal
 * page (sign-in, account) may return to.
 */
const app_base_binding_route_1 = require("./app-base-binding-route");
/** The normalized path of a page; null for a path that leaves the container. */
function appArtifactRoutePath(rawPath) {
    let decoded;
    try {
        decoded = decodeURIComponent(rawPath || '/').replace(/\\/g, '/');
    }
    catch {
        return null;
    }
    const parts = decoded.split('/').filter(Boolean);
    if (decoded.includes('://') ||
        decoded.startsWith('//') ||
        parts.some(part => part === '..' || part === '.'))
        return null;
    return `/${parts.join('/')}`;
}
/** The page at a normalized path: an exact page before a dynamic one. */
function findAppArtifactRoute(routes, path) {
    const exact = routes.find(route => appArtifactRoutePath(route.path) === path);
    if (exact)
        return exact;
    const segments = path.split('/').filter(Boolean);
    return (routes.find(route => {
        const pattern = (appArtifactRoutePath(route.path) ?? '')
            .split('/')
            .filter(Boolean);
        return (pattern.length === segments.length &&
            pattern.every((segment, index) => (0, app_base_binding_route_1.appRouteSegmentMatches)(segment, segments[index])));
    }) ?? null);
}
const PORTAL_RETURN_PATH_MAX = 2048;
/**
 * A page of this container a portal page may return to, as an encoded
 * container-relative path; null for anything else (host, scheme, unknown page).
 */
function resolvePortalReturnPath(routes, rawPath) {
    if (!rawPath.startsWith('/') || rawPath.length > PORTAL_RETURN_PATH_MAX)
        return null;
    const path = appArtifactRoutePath(rawPath);
    if (path === null || !findAppArtifactRoute(routes, path))
        return null;
    return path.split('/').map(encodeURIComponent).join('/');
}
